/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo } from "react";
import { Tabs, message, Spin } from "antd";
import API from "../../api";
import urls from "../../api/urls";
import { useLocation, useParams } from "react-router-dom";
import Heading from "../../components/Heading";
import CashRateCard from "../RateCalculator/CashRateCard";

const { GET_RATE_CARD_QUOTATION, GET_RATECARD_BY_USER, GET_RATECARD_BY_NAME } =
  urls;

const RateCards = ({ companyId }) => {
  const currentEnv = process.env.REACT_APP_ENV;
  const history = useLocation();
  const [loader, setLoader] = useState(false);
  const [cashData, setCashData] = useState({});
  const [accountData, setAccountData] = useState({});
  const [activeKey, setActiveKey] = useState(1);
  const [rateCardsData, setRateCardsData] = useState([]);

  useEffect(() => {
    //if (quotationId) {
    getQuotationDetail();
    //console.log(history);

    //}
  }, [history?.state]);

  const changeTab = (key) => {
    setActiveKey(key);
  };

  const getQuotationDetail = async () => {
    try {
      setLoader(true);

      let res;

      let data = [];
      const companyId =
        JSON.parse(localStorage.getItem("selectedCompany"))?.key || null;
      res = await API.Api(GET_RATECARD_BY_USER + companyId).get();
      data = res?.response?.data || [];

      setRateCardsData(data);
      setLoader(false);
    } catch (error) {
      message.error("Failed to fetch quotation details.");
    } finally {
      setLoader(false);
    }
  };

  // let rateCardsData_ = [
  //   {
  //     _id: "67a9f861969dddd99d9ab2aa",
  //     rateCardId: "1724159487",
  //     approvalStatus: "APPROVED",
  //     billingCycle: "Monthly",
  //     charges: [
  //       {
  //         chargesHead: "insuranceCharges",
  //         rateType: "PERCENTAGE",
  //         pricingType: "FIXED",
  //         appliesOn: "SHIPMENT",
  //         calculationBasis: "shipmentAmount",
  //         rate: null,
  //         name: null,
  //         percentage: 0,
  //       },
  //       {
  //         chargesHead: "valuationCharges",
  //         rateType: "PERCENTAGE",
  //         pricingType: "FIXED",
  //         appliesOn: "SHIPMENT",
  //         calculationBasis: "shipmentAmount",
  //         rate: null,
  //         name: null,
  //         percentage: 1,
  //       },
  //       {
  //         chargesHead: "podCharges",
  //         rateType: "PERCENTAGE",
  //         pricingType: "FIXED",
  //         appliesOn: "SHIPMENT",
  //         calculationBasis: "fixed",
  //         rate: null,
  //         name: null,
  //         percentage: 0,
  //       },
  //     ],
  //     commission: [],
  //     createdAt: "2025-02-10T13:00:17.771Z",
  //     fromDate: "2025-05-05T08:49:19.497Z",
  //     invoiceType: "Reverse-Slab",
  //     isActive: true,
  //     isDeleted: false,
  //     name: "SMILE-Q-10171-TN-0001",
  //     rates: [
  //       {
  //         type: "CASH",
  //         rate: {
  //           dox: {
  //             surface: {
  //               standard: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 50,
  //                   local: 25,
  //                   withinZone: 40,
  //                   metro: 120,
  //                   roi: 130,
  //                   specialLocation: 150,
  //                   "A.P & T.L ZONE": 50,
  //                   "KARNATAKA ZONE": 50,
  //                   "KERALA ZONE": 50,
  //                   "PONDICHERRY STATE": 40,
  //                 },
  //                 {
  //                   minValue: 51,
  //                   maxValue: 100,
  //                   local: 25,
  //                   withinZone: 40,
  //                   metro: 120,
  //                   roi: 130,
  //                   specialLocation: 150,
  //                   "A.P & T.L ZONE": 50,
  //                   "KARNATAKA ZONE": 50,
  //                   "KERALA ZONE": 50,
  //                   "PONDICHERRY STATE": 40,
  //                 },
  //                 {
  //                   minValue: 101,
  //                   maxValue: 250,
  //                   local: 25,
  //                   withinZone: 40,
  //                   metro: 120,
  //                   roi: 130,
  //                   specialLocation: 150,
  //                   "A.P & T.L ZONE": 50,
  //                   "KARNATAKA ZONE": 50,
  //                   "KERALA ZONE": 50,
  //                   "PONDICHERRY STATE": 40,
  //                 },
  //                 {
  //                   minValue: 251,
  //                   maxValue: 500,
  //                   local: 40,
  //                   withinZone: 65,
  //                   metro: 160,
  //                   roi: 170,
  //                   specialLocation: 180,
  //                   "A.P & T.L ZONE": 70,
  //                   "KARNATAKA ZONE": 70,
  //                   "KERALA ZONE": 70,
  //                   "PONDICHERRY STATE": 65,
  //                 },
  //                 {
  //                   minValue: 501,
  //                   maxValue: 750,
  //                   local: 50,
  //                   withinZone: 75,
  //                   metro: 195,
  //                   roi: 200,
  //                   specialLocation: 220,
  //                   "A.P & T.L ZONE": 80,
  //                   "KARNATAKA ZONE": 80,
  //                   "KERALA ZONE": 80,
  //                   "PONDICHERRY STATE": 75,
  //                 },
  //                 {
  //                   minValue: 751,
  //                   maxValue: 1000,
  //                   local: 50,
  //                   withinZone: 75,
  //                   metro: 195,
  //                   roi: 200,
  //                   specialLocation: 220,
  //                   "A.P & T.L ZONE": 80,
  //                   "KARNATAKA ZONE": 80,
  //                   "KERALA ZONE": 80,
  //                   "PONDICHERRY STATE": 75,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 500,
  //                   local: 25,
  //                   withinZone: 37,
  //                   metro: 97,
  //                   roi: 100,
  //                   specialLocation: 110,
  //                   "A.P & T.L ZONE": 40,
  //                   "KARNATAKA ZONE": 40,
  //                   "KERALA ZONE": 40,
  //                   "PONDICHERRY STATE": 37,
  //                 },
  //               ],
  //               fastTrack: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 50,
  //                   local: 250,
  //                   withinZone: 300,
  //                   metro: 350,
  //                   roi: 360,
  //                   specialLocation: 370,
  //                   "A.P & T.L ZONE": 320,
  //                   "KARNATAKA ZONE": 320,
  //                   "KERALA ZONE": 320,
  //                   "PONDICHERRY STATE": 300,
  //                 },
  //                 {
  //                   minValue: 51,
  //                   maxValue: 100,
  //                   local: 250,
  //                   withinZone: 300,
  //                   metro: 350,
  //                   roi: 360,
  //                   specialLocation: 370,
  //                   "A.P & T.L ZONE": 320,
  //                   "KARNATAKA ZONE": 320,
  //                   "KERALA ZONE": 320,
  //                   "PONDICHERRY STATE": 300,
  //                 },
  //                 {
  //                   minValue: 101,
  //                   maxValue: 250,
  //                   local: 250,
  //                   withinZone: 300,
  //                   metro: 380,
  //                   roi: 390,
  //                   specialLocation: 400,
  //                   "A.P & T.L ZONE": 350,
  //                   "KARNATAKA ZONE": 350,
  //                   "KERALA ZONE": 350,
  //                   "PONDICHERRY STATE": 300,
  //                 },
  //                 {
  //                   minValue: 251,
  //                   maxValue: 500,
  //                   local: 300,
  //                   withinZone: 350,
  //                   metro: 400,
  //                   roi: 420,
  //                   specialLocation: 460,
  //                   "A.P & T.L ZONE": 370,
  //                   "KARNATAKA ZONE": 370,
  //                   "KERALA ZONE": 370,
  //                   "PONDICHERRY STATE": 350,
  //                 },
  //                 {
  //                   minValue: 501,
  //                   maxValue: 750,
  //                   local: 350,
  //                   withinZone: 400,
  //                   metro: 400,
  //                   roi: 480,
  //                   specialLocation: 520,
  //                   "A.P & T.L ZONE": 400,
  //                   "KARNATAKA ZONE": 400,
  //                   "KERALA ZONE": 400,
  //                   "PONDICHERRY STATE": 400,
  //                 },
  //                 {
  //                   minValue: 751,
  //                   maxValue: 1000,
  //                   local: 350,
  //                   withinZone: 400,
  //                   metro: 475,
  //                   roi: 480,
  //                   specialLocation: 520,
  //                   "A.P & T.L ZONE": 400,
  //                   "KARNATAKA ZONE": 400,
  //                   "KERALA ZONE": 400,
  //                   "PONDICHERRY STATE": 400,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 500,
  //                   local: 175,
  //                   withinZone: 200,
  //                   metro: 237,
  //                   roi: 240,
  //                   specialLocation: 260,
  //                   "A.P & T.L ZONE": 200,
  //                   "KARNATAKA ZONE": 200,
  //                   "KERALA ZONE": 200,
  //                   "PONDICHERRY STATE": 200,
  //                 },
  //               ],
  //               valuePlus: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 50,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 51,
  //                   maxValue: 100,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 101,
  //                   maxValue: 250,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 251,
  //                   maxValue: 500,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 501,
  //                   maxValue: 750,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 751,
  //                   maxValue: 1000,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 500,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //               ],
  //             },
  //             air: {
  //               standard: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 50,
  //                   local: 25,
  //                   withinZone: 40,
  //                   metro: 120,
  //                   roi: 130,
  //                   specialLocation: 150,
  //                   "A.P & T.L ZONE": 50,
  //                   "KARNATAKA ZONE": 50,
  //                   "KERALA ZONE": 50,
  //                   "PONDICHERRY STATE": 40,
  //                 },
  //                 {
  //                   minValue: 51,
  //                   maxValue: 100,
  //                   local: 25,
  //                   withinZone: 40,
  //                   metro: 120,
  //                   roi: 130,
  //                   specialLocation: 150,
  //                   "A.P & T.L ZONE": 50,
  //                   "KARNATAKA ZONE": 50,
  //                   "KERALA ZONE": 50,
  //                   "PONDICHERRY STATE": 40,
  //                 },
  //                 {
  //                   minValue: 101,
  //                   maxValue: 250,
  //                   local: 25,
  //                   withinZone: 40,
  //                   metro: 120,
  //                   roi: 130,
  //                   specialLocation: 150,
  //                   "A.P & T.L ZONE": 50,
  //                   "KARNATAKA ZONE": 50,
  //                   "KERALA ZONE": 50,
  //                   "PONDICHERRY STATE": 40,
  //                 },
  //                 {
  //                   minValue: 251,
  //                   maxValue: 500,
  //                   local: 40,
  //                   withinZone: 65,
  //                   metro: 160,
  //                   roi: 170,
  //                   specialLocation: 180,
  //                   "A.P & T.L ZONE": 70,
  //                   "KARNATAKA ZONE": 70,
  //                   "KERALA ZONE": 70,
  //                   "PONDICHERRY STATE": 65,
  //                 },
  //                 {
  //                   minValue: 501,
  //                   maxValue: 750,
  //                   local: 50,
  //                   withinZone: 75,
  //                   metro: 195,
  //                   roi: 200,
  //                   specialLocation: 220,
  //                   "A.P & T.L ZONE": 80,
  //                   "KARNATAKA ZONE": 80,
  //                   "KERALA ZONE": 80,
  //                   "PONDICHERRY STATE": 75,
  //                 },
  //                 {
  //                   minValue: 751,
  //                   maxValue: 1000,
  //                   local: 50,
  //                   withinZone: 75,
  //                   metro: 195,
  //                   roi: 200,
  //                   specialLocation: 220,
  //                   "A.P & T.L ZONE": 80,
  //                   "KARNATAKA ZONE": 80,
  //                   "KERALA ZONE": 80,
  //                   "PONDICHERRY STATE": 75,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 500,
  //                   local: 25,
  //                   withinZone: 37,
  //                   metro: 97,
  //                   roi: 100,
  //                   specialLocation: 110,
  //                   "A.P & T.L ZONE": 40,
  //                   "KARNATAKA ZONE": 40,
  //                   "KERALA ZONE": 40,
  //                   "PONDICHERRY STATE": 37,
  //                 },
  //               ],
  //               fastTrack: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 50,
  //                   local: 250,
  //                   withinZone: 300,
  //                   metro: 350,
  //                   roi: 360,
  //                   specialLocation: 370,
  //                   "A.P & T.L ZONE": 320,
  //                   "KARNATAKA ZONE": 320,
  //                   "KERALA ZONE": 320,
  //                   "PONDICHERRY STATE": 300,
  //                 },
  //                 {
  //                   minValue: 51,
  //                   maxValue: 100,
  //                   local: 250,
  //                   withinZone: 300,
  //                   metro: 350,
  //                   roi: 360,
  //                   specialLocation: 370,
  //                   "A.P & T.L ZONE": 320,
  //                   "KARNATAKA ZONE": 320,
  //                   "KERALA ZONE": 320,
  //                   "PONDICHERRY STATE": 300,
  //                 },
  //                 {
  //                   minValue: 101,
  //                   maxValue: 250,
  //                   local: 250,
  //                   withinZone: 300,
  //                   metro: 380,
  //                   roi: 390,
  //                   specialLocation: 400,
  //                   "A.P & T.L ZONE": 350,
  //                   "KARNATAKA ZONE": 350,
  //                   "KERALA ZONE": 350,
  //                   "PONDICHERRY STATE": 300,
  //                 },
  //                 {
  //                   minValue: 251,
  //                   maxValue: 500,
  //                   local: 300,
  //                   withinZone: 350,
  //                   metro: 400,
  //                   roi: 420,
  //                   specialLocation: 460,
  //                   "A.P & T.L ZONE": 370,
  //                   "KARNATAKA ZONE": 370,
  //                   "KERALA ZONE": 370,
  //                   "PONDICHERRY STATE": 350,
  //                 },
  //                 {
  //                   minValue: 501,
  //                   maxValue: 750,
  //                   local: 350,
  //                   withinZone: 400,
  //                   metro: 400,
  //                   roi: 480,
  //                   specialLocation: 520,
  //                   "A.P & T.L ZONE": 400,
  //                   "KARNATAKA ZONE": 400,
  //                   "KERALA ZONE": 400,
  //                   "PONDICHERRY STATE": 400,
  //                 },
  //                 {
  //                   minValue: 751,
  //                   maxValue: 1000,
  //                   local: 350,
  //                   withinZone: 400,
  //                   metro: 475,
  //                   roi: 480,
  //                   specialLocation: 520,
  //                   "A.P & T.L ZONE": 400,
  //                   "KARNATAKA ZONE": 400,
  //                   "KERALA ZONE": 400,
  //                   "PONDICHERRY STATE": 400,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 500,
  //                   local: 175,
  //                   withinZone: 200,
  //                   metro: 237,
  //                   roi: 240,
  //                   specialLocation: 260,
  //                   "A.P & T.L ZONE": 200,
  //                   "KARNATAKA ZONE": 200,
  //                   "KERALA ZONE": 200,
  //                   "PONDICHERRY STATE": 200,
  //                 },
  //               ],
  //               valuePlus: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 50,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 51,
  //                   maxValue: 100,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 101,
  //                   maxValue: 250,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 251,
  //                   maxValue: 500,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 501,
  //                   maxValue: 750,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 751,
  //                   maxValue: 1000,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 500,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //               ],
  //             },
  //           },
  //           nonDox: {
  //             surface: {
  //               standard: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 1000,
  //                   local: 35,
  //                   withinZone: 50,
  //                   metro: 90,
  //                   roi: 100,
  //                   specialLocation: 130,
  //                   "A.P & T.L ZONE": 70,
  //                   "KARNATAKA ZONE": 70,
  //                   "KERALA ZONE": 70,
  //                   "PONDICHERRY STATE": 50,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 1000,
  //                   local: 35,
  //                   withinZone: 50,
  //                   metro: 90,
  //                   roi: 100,
  //                   specialLocation: 130,
  //                   "A.P & T.L ZONE": 70,
  //                   "KARNATAKA ZONE": 70,
  //                   "KERALA ZONE": 70,
  //                   "PONDICHERRY STATE": 50,
  //                 },
  //               ],
  //               fastTrack: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 1000,
  //                   local: 350,
  //                   withinZone: 370,
  //                   metro: 450,
  //                   roi: 480,
  //                   specialLocation: 540,
  //                   "A.P & T.L ZONE": 400,
  //                   "KARNATAKA ZONE": 400,
  //                   "KERALA ZONE": 400,
  //                   "PONDICHERRY STATE": 370,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 1000,
  //                   local: 350,
  //                   withinZone: 370,
  //                   metro: 450,
  //                   roi: 480,
  //                   specialLocation: 540,
  //                   "A.P & T.L ZONE": 400,
  //                   "KARNATAKA ZONE": 400,
  //                   "KERALA ZONE": 400,
  //                   "PONDICHERRY STATE": 370,
  //                 },
  //               ],
  //               valuePlus: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 1000,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 500,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //               ],
  //             },
  //             air: {
  //               standard: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 1000,
  //                   local: 35,
  //                   withinZone: 50,
  //                   metro: 170,
  //                   roi: 180,
  //                   specialLocation: 210,
  //                   "A.P & T.L ZONE": 70,
  //                   "KARNATAKA ZONE": 70,
  //                   "KERALA ZONE": 70,
  //                   "PONDICHERRY STATE": 50,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 1000,
  //                   local: 35,
  //                   withinZone: 50,
  //                   metro: 170,
  //                   roi: 180,
  //                   specialLocation: 210,
  //                   "A.P & T.L ZONE": 70,
  //                   "KARNATAKA ZONE": 70,
  //                   "KERALA ZONE": 70,
  //                   "PONDICHERRY STATE": 50,
  //                 },
  //               ],
  //               fastTrack: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 1000,
  //                   local: 350,
  //                   withinZone: 370,
  //                   metro: 450,
  //                   roi: 480,
  //                   specialLocation: 540,
  //                   "A.P & T.L ZONE": 400,
  //                   "KARNATAKA ZONE": 400,
  //                   "KERALA ZONE": 400,
  //                   "PONDICHERRY STATE": 370,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 1000,
  //                   local: 350,
  //                   withinZone: 370,
  //                   metro: 450,
  //                   roi: 480,
  //                   specialLocation: 540,
  //                   "A.P & T.L ZONE": 400,
  //                   "KARNATAKA ZONE": 400,
  //                   "KERALA ZONE": 400,
  //                   "PONDICHERRY STATE": 370,
  //                 },
  //               ],
  //               valuePlus: [
  //                 {
  //                   minValue: 0,
  //                   maxValue: 1000,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //                 {
  //                   minValue: 1001,
  //                   volume: 500,
  //                   local: 0,
  //                   withinZone: 0,
  //                   metro: 0,
  //                   roi: 0,
  //                   specialLocation: 0,
  //                 },
  //               ],
  //             },
  //           },
  //         },
  //       },
  //     ],
  //     toDate: "2026-03-31T23:59:59.000Z",
  //     updatedAt: "2025-06-13T13:51:33.145Z",
  //     userId: "10171",
  //     type: "CASH",
  //   },
  // ];

  const tabItems = rateCardsData?.map((item, index) => ({
    label: item.type, // Tab Title
    key: index + 1, // Unique Key
    children: <CashRateCard data={item} />, // Tab Content
  }));

  console.log(rateCardsData, "rateCardsData");

  return (
    <Spin spinning={loader}>
      {rateCardsData?.length > 0 ? (
        <Tabs
          type="card"
          items={tabItems}
          activeKey={activeKey}
          onChange={changeTab}
          className="rate-card-tab"
        />
      ) : (
        <div className="no-data-prresnt">
          No rate card has been configured, please contact to HO team.
        </div>
      )}
    </Spin>
  );
};

export default RateCards;
